export default "__VITE_ASSET__34317b12__"